import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy, inject } from '@angular/core';
import { GrantService } from '../services/grant.service';
import { ResourceType } from '../enums/resource-type.enum';
import { ActionType } from '../enums/action-type.enum';
import { Subscription } from 'rxjs';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[hasGrant]',
})
export class HasGrantDirective implements OnDestroy {
	private subscription: Subscription;
	private hasView = false;

	private _resource: ResourceType;
	private _action: ActionType = ActionType.READ;

	private templateRef = inject<TemplateRef<any>>(TemplateRef);
	private viewContainer = inject(ViewContainerRef);
	private grantService = inject(GrantService);

	constructor() {
		this.subscription = this.grantService.role$.subscribe((role) => {
			if (role) {
				this.updateView();
			}
		});
	}

	@Input('hasGrant') set appHasGrant(value: { resource: ResourceType; action?: ActionType }) {
		this._resource = value.resource;
		this._action = value.action ?? ActionType.READ;
		this.updateView();
	}

	private updateView(): void {
		const hasPermission = this.grantService.getGrant(this._resource, this._action);

		if (hasPermission && !this.hasView) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			this.hasView = true;
		} else if (!hasPermission && this.hasView) {
			this.viewContainer.clear();
			this.hasView = false;
		}
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}
}
